export default "__VITE_ASSET__hikdt56V__"